export const key = "kQfoTxSAzYoCzlc6IqMXiT2CaJFtDhAp";  // same as serverCode's SECREAT_KEY

export const baseURL = process.env.REACT_APP_API_BASE_URL;  // same as serverCode's BASE_URL  [  example: https://example.live.com/  ]
